import { useEffect, useState } from "react";
import { useAuth } from "hooks/useAuth";
import { db } from "services/firebase";

/**
 * Count of pending (not completed) med-rec docs for the signed-in patient.
 */
export function usePendingEhrMedRecCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user?.uid) {
      setCount(0);
      return undefined;
    }
    const unsub = db
      .collection("pendingMedReconciliations")
      .doc(user.uid)
      .collection("items")
      .onSnapshot(
        (snap) => {
          let n = 0;
          snap.forEach((doc) => {
            if (doc.data()?.status !== "completed") n += 1;
          });
          setCount(n);
        },
        () => setCount(0),
      );
    return () => unsub();
  }, [user?.uid]);

  return count;
}
